import appSettings from 'wanderu-config';
import { actionDuckUtils } from 'wanderu-ducks-utils';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';

import {
    getContent,
} from '../../../services';
import generateLocaleAwarePolicyIndex from '../../../utils';
import {
    setContentData,
} from '../../appstate/actions';
import sliceNamespace from '../../types';

const namespace = 'FETCH_TC_CONTENT';

const {
    actions,
    reducer,
    selectors,
} = actionDuckUtils.buildBaseDuck(namespace, sliceNamespace, generateLocaleAwarePolicyIndex);

const logger = Logger.getLogger('fetchTermsAndConditionsContent');

function fetchTCContent(params) {
    const {
        locale,
        policy,
    } = params;

    if (!locale || !policy) {
        throw new Error('missing required params');
    }

    return async (dispatch) => {
        let error = null;

        dispatch(actions.startWork(params));

        try {
            const template = await getContent(params);
            return dispatch(setContentData(params, template));
        } catch (ex) {
            logger.error('fetch', ex);
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            logger.error('fetch', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });

            error = {
                code: ex.code,
                message: 'fetch terms and conditions content failed',
                name: ex.code,
                status: ex.responseBody.error.status,
            };
        } finally {
            dispatch(actions.endWork(params, undefined, error));
        }
    };
}

const fetchTCContentAction = {
    fetchTCContent,
    ...selectors,
};

export {
    actions,
    fetchTCContentAction,
};
export default {
    [namespace]: reducer,
};
